import { Dispatch } from 'redux'
import { locationService } from '../../../services/Location'
import { membershipRequestService } from '../../../services/MembershipRequest'
import { riderService } from '../../../services/Rider'
import promotionsService from '../../../services/Promotions'
import { tripService } from '../../../services/Trip'
import {
  ActionsUnion,
  IAutochargeConfigResponseDTO,
  IMap,
  IMembershipObject,
  IRiderLocationObject,
  IRiderMobilityObject,
  IRiderObject,
  IRiderSearchObject,
  ISearchRider,
  IWalletResponseDTO,
  IWalletTransactionResponseDTO,
  IWalletWithSources,
  IRiderFilters,
  IApplyPromotion,
  IAppliedPromotion,
  IRiderActivityLocationObject,
  ITripRequestObject,
  IRefundTransactionDTO,
  IRiderChangeLogDTO,
  IUpdateServiceMemberships
} from '../../../types'
import { createAction } from '../helpers'
import * as constants from '../../constants'
import { membershipListFail, membershipListRequest, membershipListSuccess } from '../membership_request/index'
import { actionCreators as organizationActionCreators } from '../organizations/index'
import history from '../../../history'
import { dispatch } from 'react-hot-toast/dist/core/store'
import user from 'src/state/reducers/users'
import { ILogEntryResponseDTO } from 'src/types/log-entry'
;(window as any).riderService = riderService

//TODO figure out what's up here
export const autoCompleteLocations = (value: string): any => locationService.search(value).then(({ data }) => data)

export type IRiderAction = ActionsUnion<typeof actionCreators>
export const actionCreators = {
  //Sync action creators
  ridersCreateUpdateLocation: () => createAction(constants.RIDERS_CREATE_UPDATE_LOCATION),
  ridersCreateClear: () => createAction(constants.RIDERS_CREATE_CLEAR),
  ridersClearSearch: () => createAction(constants.CLEAR_RIDER_SEARCH),

  //Async action creators
  ridersListRequest: () => createAction(constants.RIDER_LIST_REQUEST),
  ridersListSuccess: (ridersWithTotal: { total: number; items: IRiderSearchObject[] }) =>
    createAction(constants.RIDER_LIST_SUCCESS, ridersWithTotal),
  ridersListFailure: (error: string) => createAction(constants.RIDER_LIST_FAILURE, error),

  fetchRidersJoinRequest: () => createAction(constants.RIDER_LIST_REQUEST),
  fetchRidersJoinRequestSuccess: (ridersWithTotal: { total: number; items: IRiderSearchObject[] }) =>
    createAction(constants.RIDER_LIST_SUCCESS, ridersWithTotal),
  fetchRidersJoinRequestFailure: (error: string) => createAction(constants.RIDER_LIST_FAILURE, error),

  ridersLocationListRequest: () => createAction(constants.RIDER_LOCATION_LIST_REQUEST),
  ridersLocationListSuccess: (riderId: string, locationList: IRiderLocationObject[]) =>
    createAction(constants.RIDER_LOCATION_LIST_SUCCESS, { riderId, locationList }),
  ridersLocationListFailure: (error: string) => createAction(constants.RIDER_LOCATION_LIST_FAILURE, error),

  ridersLocationActivityListRequest: () => createAction(constants.RIDER_LOCATION_ACTIVITY_LIST_REQUEST),
  ridersLocationActivityListSuccess: (riderId: string, locationList: IRiderActivityLocationObject[]) =>
    createAction(constants.RIDER_LOCATION_ACTIVITY_LIST_SUCCESS, { riderId, locationList }),
  ridersLocationActivityListFailure: (error: string) =>
    createAction(constants.RIDER_LOCATION_ACTIVITY_LIST_FAILURE, error),
  ridersMembershipListRequest: () => createAction(constants.RIDER_MEMBERSHIP_LIST_REQUEST),
  ridersMembershipListSuccess: (riderId: string, membershipList: IMembershipObject[]) =>
    createAction(constants.RIDER_MEMBERSHIP_LIST_SUCCESS, { riderId, membershipList }),
  ridersMembershipListFailure: (error: string) => createAction(constants.RIDER_MEMBERSHIP_LIST_FAILURE, error),

  riderMembershipUpdateRequest: () => createAction(constants.RIDER_MEMBERSHIP_UPDATE_REQUEST),
  riderMembershipUpdateSuccess: (riderId: string) => createAction(constants.RIDER_MEMBERSHIP_UPDATE_SUCCESS, riderId),
  riderMembershipUpdateFailure: (error: string) => createAction(constants.RIDER_MEMBERSHIP_UPDATE_FAILURE, error),

  ridersPersonalInfoRequest: () => createAction(constants.RIDER_PERSONAL_INFO_REQUEST),
  ridersPersonalInfoSuccess: (rider: IRiderObject) => createAction(constants.RIDER_PERSONAL_INFO_SUCCESS, rider),
  ridersPersonalInfoFailure: (error: string) => createAction(constants.RIDER_PERSONAL_INFO_FAILURE, error),

  ridersDetailsSuspendMembershipRequest: () => createAction(constants.RIDERS_DETAILS_SUSPEND_MEMBERSHIP_REQUEST),
  ridersDetailsSuspendMembershipSuccess: (membership: IMembershipObject) =>
    createAction(constants.RIDERS_DETAILS_SUSPEND_MEMBERSHIP_SUCCESS, membership),
  ridersDetailsSuspendMembershipFailure: (error: string) =>
    createAction(constants.RIDERS_DETAILS_SUSPEND_MEMBERSHIP_FAILURE, error),

  ridersSearchRequest: (dto: ISearchRider) => createAction(constants.RIDERS_SEARCH_REQUEST, dto),
  ridersSearchSuccess: (ridersWithTotal: { total: number; riders: IMap<IRiderObject> }) =>
    createAction(constants.RIDERS_SEARCH_SUCCESS, ridersWithTotal),
  ridersSearchFailure: (error: string) => createAction(constants.RIDERS_SEARCH_FAILURE, error),

  tripRiderSearchRequest: (dto: IRiderFilters) => createAction(constants.TRIP_RIDER_SEARCH_REQUEST, dto),
  tripRiderSearchSuccess: (ridersWithTotal: { total: number; items: IRiderSearchObject[] }) =>
    createAction(constants.TRIP_RIDER_SEARCH_SUCCESS, ridersWithTotal),
  tripRiderSearchFailure: (error: string) => createAction(constants.TRIP_RIDER_SEARCH_FAIL, error),

  ridersCreateRequest: () => createAction(constants.RIDERS_CREATE_REQUEST),
  ridersCreateSuccess: (rider: IRiderObject) => createAction(constants.RIDERS_CREATE_SUCCESS, rider),
  ridersCreateFailure: (error: string) => createAction(constants.RIDERS_CREATE_FAILURE, error),

  ridersActivateRequest: () => createAction(constants.RIDERS_ACTIVATE_REQUEST),
  ridersActivateSuccess: (rider: IRiderObject) => createAction(constants.RIDERS_ACTIVATE_SUCCESS, rider),
  ridersActivateFailure: (error: string, rider: IRiderObject) =>
    createAction(constants.RIDERS_ACTIVATE_FAILURE, { error, rider }),

  ridersDeactivateRequest: () => createAction(constants.RIDERS_DEACTIVATE_REQUEST),
  ridersDeactivateSuccess: (rider: IRiderObject) => createAction(constants.RIDERS_DEACTIVATE_SUCCESS, rider),
  ridersDeactivateFailure: (error: string, rider: IRiderObject) =>
    createAction(constants.RIDERS_DEACTIVATE_FAILURE, { error, rider }),

  ridersArchiveRequest: () => createAction(constants.RIDERS_ARCHIVE_REQUEST),
  ridersArchiveSuccess: (rider: IRiderObject) => createAction(constants.RIDERS_ARCHIVE_SUCCESS, rider),
  ridersArchiveFailure: (error: string, rider: IRiderObject) =>
    createAction(constants.RIDERS_ARCHIVE_FAILURE, { error, rider }),

  ridersRestoreArchiveRequest: () => createAction(constants.RIDERS_RESTORE_ARCHIVE_REQUEST),
  ridersRestoreArchiveSuccess: (rider: IRiderObject) => createAction(constants.RIDERS_RESTORE_ARCHIVE_SUCCESS, rider),
  ridersRestoreArchiveFailure: (error: string, rider: IRiderObject) =>
    createAction(constants.RIDERS_RESTORE_ARCHIVE_FAILURE, { error, rider }),

  ridersAssistanceListRequest: () => createAction(constants.RIDER_ASSISTANCE_LIST_REQUEST),
  ridersAssistanceListSuccess: (riderId: string, assistanceList: string[]) =>
    createAction(constants.RIDER_ASSISTANCE_LIST_SUCCESS, { riderId, assistanceList }),
  ridersAssistanceListFailure: (error: string) => createAction(constants.RIDER_ASSISTANCE_LIST_FAILURE, error),

  ridersUpdateAssistancesRequest: () => createAction(constants.RIDERS_UPDATE_ASSISTANCES_REQUEST),
  ridersUpdateAssistancesSuccess: (rider: IRiderObject, assistances: string[]) =>
    createAction(constants.RIDERS_UPDATE_ASSISTANCES_SUCCESS, { rider, assistances }),
  ridersUpdateAssistancesFailure: (error: string) => createAction(constants.RIDERS_UPDATE_ASSISTANCES_FAILURE, error),

  ridersUpdateLocationsRequest: () => createAction(constants.RIDERS_UPDATE_LOCATIONS_REQUEST),
  ridersUpdateLocationsSuccess: (rider: IRiderObject, locations: IRiderLocationObject[]) =>
    createAction(constants.RIDERS_UPDATE_LOCATIONS_SUCCESS, { rider, locations }),
  ridersUpdateLocationsFailure: (error: string) => createAction(constants.RIDERS_UPDATE_LOCATIONS_FAILURE, error),

  ridersUpdateMembershipsRequest: () => createAction(constants.RIDERS_UPDATE_MEMBERSHIPS_REQUEST),
  ridersUpdateMembershipsSuccess: (rider: IRiderObject, memberships: IMembershipObject[]) =>
    createAction(constants.RIDERS_UPDATE_MEMBERSHIPS_SUCCESS, { rider, memberships }),
  ridersUpdateMembershipsFailure: (error: string) => createAction(constants.RIDERS_UPDATE_MEMBERSHIPS_FAILURE, error),

  ridersMobilityOptionsListRequest: () => createAction(constants.RIDER_MOBILITY_OPTION_LIST_REQUEST),
  ridersMobilityOptionsListSuccess: (riderId: string, mobilityOptionList: IRiderMobilityObject[]) =>
    createAction(constants.RIDER_MOBILITY_OPTION_LIST_SUCCESS, { riderId, mobilityOptionList }),
  ridersMobilityOptionsListFailure: (error: string) =>
    createAction(constants.RIDER_MOBILITY_OPTION_LIST_FAILURE, error),

  ridersUpdateMobilitiesRequest: () => createAction(constants.RIDERS_UPDATE_MOBILITIES_REQUEST),
  ridersUpdateMobilitiesSuccess: (
    riderId: string,
    mobilityOptionList: IRiderMobilityObject[],
    allowAttendant: boolean
  ) => createAction(constants.RIDERS_UPDATE_MOBILITIES_SUCCESS, { riderId, mobilityOptionList, allowAttendant }),
  ridersUpdateMobilitiesFailure: (error: string) => createAction(constants.RIDERS_UPDATE_MOBILITIES_FAILURE, error),

  ridersUpdatePersonalInfoRequest: () => createAction(constants.RIDERS_UPDATE_PERSONAL_INFO_REQUEST),
  ridersUpdatePersonalInfoSuccess: (rider: IRiderObject) =>
    createAction(constants.RIDERS_UPDATE_PERSONAL_INFO_SUCCESS, { rider }),
  ridersUpdatePersonalInfoFailure: (error: string) =>
    createAction(constants.RIDERS_UPDATE_PERSONAL_INFO_FAILURE, error),

  ridersAddPaymentSourceRequest: () => createAction(constants.RIDERS_ADD_PAYMENT_SOURCE_REQUEST),
  ridersAddPaymentSourceSuccess: (wallet: IWalletWithSources, riderId: string) =>
    createAction(constants.RIDERS_ADD_PAYMENT_SOURCE_SUCCESS, { wallet, riderId }),
  ridersAddPaymentSourceFailure: (error: string) => createAction(constants.RIDERS_ADD_PAYMENT_SOURCE_FAILURE, error),

  ridersUpdateDefaultPaymentSourceRequest: () => createAction(constants.RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_REQUEST),
  ridersUpdateDefaultPaymentSourceSuccess: (wallet: IWalletWithSources, riderId: string) =>
    createAction(constants.RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_SUCCESS, { wallet, riderId }),
  ridersUpdateDefaultPaymentSourceFailure: (error: string) =>
    createAction(constants.RIDERS_UPDATE_DEFAULT_PAYMENT_SOURCE_FAILURE, error),

  ridersRemovePaymentSourceRequest: () => createAction(constants.RIDERS_REMOVE_PAYMENT_SOURCE_REQUEST),
  ridersRemovePaymentSourceSuccess: (paymentSourceId: string, riderId: string) =>
    createAction(constants.RIDERS_REMOVE_PAYMENT_SOURCE_SUCCESS, { paymentSourceId, riderId }),
  ridersRemovePaymentSourceFailure: (error: string) =>
    createAction(constants.RIDERS_REMOVE_PAYMENT_SOURCE_FAILURE, error),

  ridersWalletTransactionsRequest: (riderId: string) =>
    createAction(constants.RIDERS_WALLET_TRANSACTIONS_REQUEST, riderId),
  ridersWalletTransactionsSuccess: (riderId: string, transactions: IWalletTransactionResponseDTO[]) =>
    createAction(constants.RIDERS_WALLET_TRANSACTIONS_SUCCESS, { riderId, transactions }),
  ridersWalletTransactionsFailure: (error: string, riderId: string) =>
    createAction(constants.RIDERS_WALLET_TRANSACTIONS_FAILURE, { error, riderId }),

  ridersWalletTransactionHistoryRequest: (riderId: string) =>
    createAction(constants.RIDERS_WALLET_TRANSACTION_HISTORY_REQUEST, riderId),
  ridersWalletTransactionHistorySuccess: (riderId: string, transactions: IWalletTransactionResponseDTO[]) =>
    createAction(constants.RIDERS_WALLET_TRANSACTION_HISTORY_SUCCESS, { riderId, transactions }),
  ridersWalletTransactionHistoryFailure: (error: string, riderId: string) =>
    createAction(constants.RIDERS_WALLET_TRANSACTION_HISTORY_FAILURE, { error, riderId }),

  ridersUpdateAutochargeRequest: (riderId: string) =>
    createAction(constants.RIDERS_UPDATE_WALLET_AUTOCHARGE_REQUEST, riderId),
  ridersUpdateAutochargeSuccess: (riderId: string, autochargeConfig: IAutochargeConfigResponseDTO) =>
    createAction(constants.RIDERS_UPDATE_WALLET_AUTOCHARGE_SUCCESS, { riderId, autochargeConfig }),
  ridersUpdateAutochargeFailure: (error: string) =>
    createAction(constants.RIDERS_UPDATE_WALLET_AUTOCHARGE_FAILURE, error),

  ridersAutochargeRequest: (riderId: string) => createAction(constants.RIDERS_FETCH_WALLET_AUTOCHARGE_REQUEST, riderId),
  ridersAutochargeSuccess: (riderId: string, autochargeConfig: IAutochargeConfigResponseDTO) =>
    createAction(constants.RIDERS_FETCH_WALLET_AUTOCHARGE_SUCCESS, { riderId, autochargeConfig }),
  ridersAutochargeFailure: (error: string, riderId: string) =>
    createAction(constants.RIDERS_FETCH_WALLET_AUTOCHARGE_FAILURE, { error, riderId }),

  ridersWalletRequest: (riderId: string) => createAction(constants.RIDERS_WALLET_REQUEST, riderId),
  ridersWalletSuccess: (riderId: string, wallet: IWalletWithSources) =>
    createAction(constants.RIDERS_WALLET_SUCCESS, { wallet, riderId }),
  ridersWalletFailure: (error: string, riderId: string) =>
    createAction(constants.RIDERS_WALLET_FAILURE, { error, riderId }),

  ridersAddFundsToWalletRequest: (riderId: string) =>
    createAction(constants.RIDERS_ADD_FUNDS_TO_WALLET_REQUEST, riderId),
  ridersAddFundsToWalletSuccess: (riderId: string, wallet: IWalletResponseDTO) =>
    createAction(constants.RIDERS_ADD_FUNDS_TO_WALLET_SUCCESS, { wallet, riderId }),
  ridersAddFundsToWalletFailure: (error: string, riderId: string) =>
    createAction(constants.RIDERS_ADD_FUNDS_TO_WALLET_FAILURE, { error, riderId }),

  ridersAddBonusToWalletRequest: (riderId: string) =>
    createAction(constants.RIDERS_ADD_BONUS_TO_WALLET_REQUEST, riderId),
  ridersAddBonusToWalletSuccess: (riderId: string, wallet: IWalletResponseDTO) =>
    createAction(constants.RIDERS_ADD_BONUS_TO_WALLET_SUCCESS, { wallet, riderId }),
  ridersAddBonusToWalletFailure: (error: string, riderId: string) =>
    createAction(constants.RIDERS_ADD_BONUS_TO_WALLET_FAILURE, { error, riderId }),

  clearRiderCreate: () => createAction(constants.RIDERS_CREATE_FINISH),

  applyPromotion: (userId: string) => createAction(constants.APPLY_PROMOTION, { userId }),
  applyPromotionSuccess: (promotion: IAppliedPromotion) => createAction(constants.APPLY_PROMOTION_SUCCESS, promotion),
  applyPromotionFailure: (error: string) => createAction(constants.APPLY_PROMOTION_FAIL, error),

  deleteAppliedPromotionFailure: (error: string) => createAction(constants.DELETE_APPLIED_PROMOTIONS_FAILURE, error),

  getAppliedPromotions: (userId: string) => createAction(constants.GET_APPLIED_PROMOTIONS, { userId }),
  getAppliedPromotionsSuccess: (userId: string, appliedPromotions: IAppliedPromotion[]) =>
    createAction(constants.GET_APPLIED_PROMOTIONS_SUCCESS, { userId, appliedPromotions }),
  getAppliedPromotionsFailure: (error: string) => createAction(constants.GET_APPLIED_PROMOTIONS_FAILURE, error),

  getRiderRecurringTripsRequest: () => createAction(constants.RIDER_RECURRING_TRIPS_REQUEST),
  getRiderRecurringTripsSuccess: (trip: { items: ITripRequestObject[]; count: number }) =>
    createAction(constants.RIDER_RECURRING_TRIPS_SUCCESS, trip),
  getRiderRecurringTripsFailure: (error: any) => createAction(constants.RIDER_RECURRING_TRIPS_FAILURE, error),

  getRiderChangeLogRequest: () => createAction(constants.RIDER_CHANGE_LOG_REQUEST),
  getRiderChangeLogSuccess: (changelog: { items: ILogEntryResponseDTO[]; count: number }) =>
    createAction(constants.RIDER_CHANGE_LOG_SUCCESS, changelog),
  getRiderChangeLogFailure: (error: any) => createAction(constants.RIDER_CHANGE_LOG_FAILURE, error),

  destroyRecurringTripTaskSuccess: (recurringTripId: string) =>
    createAction(constants.DESTROY_RECURRING_TRIP_TASK_SUCCESS, recurringTripId),
  destroyRecurringTripTaskFailure: (error: any) => createAction(constants.DESTROY_RECURRING_TRIP_TASK_FAIL, error),

  getRefundedAmountSuccess: (value: any) => createAction(constants.GET_REFUNDED_AMOUNT_SUCCESS, value),
  getRefundedAmountFailure: (error: any) => createAction(constants.GET_REFUNDED_AMOUNT_FAILURE, error),

  refundPaymentSuccess: () => createAction(constants.REFUND_PAYMENT_SUCCESS),
  refundPaymentFailure: (error: any) => createAction(constants.REFUND_PAYMENT_FAILURE, error),

  assignRefundDetails: (params: IRefundTransactionDTO) => createAction(constants.ASSIGN_REFUND_DETAILS, params),

  rechargeWalletRequest: (walletTransactionId: string) =>
    createAction(constants.RIDERS_RECHARGE_WALLET_REQUEST, walletTransactionId),
  rechargeWalletSuccess: () => createAction(constants.RIDERS_RECHARGE_WALLET_SUCCESS),
  rechargeWalletFailure: (error: string) => createAction(constants.RIDERS_RECHARGE_WALLET_FAILURE, error)
}

export const ridersDetailsSuspendMembership = (membership: IMembershipObject) => (dispatch: any) => {
  const {
    ridersDetailsSuspendMembershipRequest,
    ridersDetailsSuspendMembershipSuccess,
    ridersDetailsSuspendMembershipFailure
  } = actionCreators
  dispatch(ridersDetailsSuspendMembershipRequest())
  return riderService.suspendMembership(membership).then(
    () => {
      dispatch(ridersDetailsSuspendMembershipSuccess(membership))
    },
    (error: string) => {
      dispatch(ridersDetailsSuspendMembershipFailure(error))
      setTimeout(() => {
        dispatch(ridersDetailsSuspendMembershipFailure(''))
      }, 5000)
    }
  )
}

export const ridersAddFundsToWallet = (
  riderId: string,
  riderName: string,
  riderEmail: string,
  paymentSourceId: string,
  amount: number,
  currentUserId: string
) => (dispatch: any) => {
  const { ridersAddFundsToWalletRequest, ridersAddFundsToWalletSuccess, ridersAddFundsToWalletFailure } = actionCreators
  dispatch(ridersAddFundsToWalletRequest(riderId))
  return riderService.addFundsToWallet(riderId, riderName, riderEmail, paymentSourceId, amount, currentUserId).then(
    (wallet: IWalletResponseDTO) => {
      // If we successfully add funds, we want the list
      // of wallet transactions to update
      dispatch(getRiderWalletTransactions(riderId))

      dispatch(ridersAddFundsToWalletSuccess(riderId, wallet))
      return wallet
    },
    (response: any) => {
      const error = response.data
      dispatch(ridersAddFundsToWalletFailure(error, riderId))
      // commented out below, ridersAddFundsToWalletFailure dispatched 2x
      // setTimeout(() => {
      //   dispatch(ridersAddFundsToWalletFailure(error, riderId))
      // }, 5000)
      return response
    }
  )
}

export const ridersAddBonusToWallet = (riderId: string, amount: number, message: string) => (dispatch: any) => {
  const { ridersAddBonusToWalletRequest, ridersAddBonusToWalletSuccess, ridersAddBonusToWalletFailure } = actionCreators
  dispatch(ridersAddBonusToWalletRequest(riderId))
  return riderService.addBonusToWallet(riderId, amount, message).then(
    (wallet: IWalletResponseDTO) => {
      // If we successfully add funds, we want the list
      // of wallet transactions to update
      dispatch(getRiderWalletTransactions(riderId))

      dispatch(ridersAddBonusToWalletSuccess(riderId, wallet))
      return wallet
    },
    (response: any) => {
      const error = response.data
      dispatch(ridersAddBonusToWalletFailure(error, riderId))
      setTimeout(() => {
        dispatch(ridersAddBonusToWalletFailure('', riderId))
      }, 5000)
      return response
    }
  )
}

export const getRiderWallet = (riderId: string) => (dispatch: any) => {
  const { ridersWalletRequest, ridersWalletSuccess, ridersWalletFailure } = actionCreators
  dispatch(ridersWalletRequest(riderId))
  return riderService.getRiderWallet(riderId).then(
    (wallet: IWalletWithSources) => {
      dispatch(ridersWalletSuccess(riderId, wallet))
    },
    (response: any) => {
      const error = response.data
      dispatch(ridersWalletFailure(error, riderId))
      setTimeout(() => {
        dispatch(ridersWalletFailure('', riderId))
      }, 5000)
    }
  )
}

export const getRiderWalletTransactions = (riderId: string) => (dispatch: any) => {
  const {
    ridersWalletTransactionsRequest,
    ridersWalletTransactionsSuccess,
    ridersWalletTransactionsFailure
  } = actionCreators
  dispatch(ridersWalletTransactionsRequest(riderId))
  return riderService.getRiderWalletTransactions(riderId).then(
    (transactions: IWalletTransactionResponseDTO[]) => {
      dispatch(ridersWalletTransactionsSuccess(riderId, transactions))
    },
    (error: string) => {
      dispatch(ridersWalletTransactionsFailure(error, riderId))
      setTimeout(() => {
        dispatch(ridersWalletTransactionsFailure('', riderId))
      }, 5000)
    }
  )
}

export const getRiderWalletTransactionHistory = (riderId: string) => (dispatch: any) => {
  const {
    ridersWalletTransactionHistoryRequest,
    ridersWalletTransactionHistorySuccess,
    ridersWalletTransactionHistoryFailure
  } = actionCreators
  dispatch(ridersWalletTransactionHistoryRequest(riderId))
  return riderService.getRiderWalletTransactionHistory(riderId).then(
    (transactions: IWalletTransactionResponseDTO[]) => {
      dispatch(ridersWalletTransactionHistorySuccess(riderId, transactions))
    },
    (error: string) => {
      dispatch(ridersWalletTransactionHistoryFailure(error, riderId))
      setTimeout(() => {
        dispatch(ridersWalletTransactionHistoryFailure('', riderId))
      }, 5000)
    }
  )
}

export const getRiderAutochargeConfig = (riderId: string) => (dispatch: any) => {
  const { ridersAutochargeRequest, ridersAutochargeSuccess, ridersAutochargeFailure } = actionCreators
  dispatch(ridersAutochargeRequest(riderId))
  return riderService.getRiderAutochargeConfig(riderId).then(
    (autochargeConfig: IAutochargeConfigResponseDTO) => {
      dispatch(ridersAutochargeSuccess(riderId, autochargeConfig))
    },
    (response: any) => {
      const error = response.data
      dispatch(ridersAutochargeFailure(error, riderId))
      setTimeout(() => {
        dispatch(ridersAutochargeFailure('', riderId))
      }, 5000)
    }
  )
}

export const updateRiderAutochargeConfig = (riderId: string, autochargeConfig: IAutochargeConfigResponseDTO) => (
  dispatch: any
) => {
  const { ridersUpdateAutochargeRequest, ridersUpdateAutochargeSuccess, ridersUpdateAutochargeFailure } = actionCreators

  dispatch(ridersUpdateAutochargeRequest(riderId))
  return riderService.updateRiderAutochargeConfig(riderId, autochargeConfig).then(
    (autochargeConfig: IAutochargeConfigResponseDTO) => {
      dispatch(ridersUpdateAutochargeSuccess(riderId, autochargeConfig))
    },
    (response: any) => {
      const error = response.data
      dispatch(ridersUpdateAutochargeFailure(error))
      setTimeout(() => {
        dispatch(ridersUpdateAutochargeFailure(''))
      }, 5000)
    }
  )
}

export const activateRider = (rider: IRiderObject) => (dispatch: any) => {
  const { ridersActivateRequest, ridersActivateSuccess, ridersActivateFailure } = actionCreators
  dispatch(ridersActivateRequest())
  return riderService.activateRider(rider.id).then(
    (response: any) => {
      rider.isActive = true
      dispatch(ridersActivateSuccess(rider))
    },
    (error: string) => {
      dispatch(ridersActivateFailure(error, rider))
    }
  )
}

export const addRiderPaymentSource = (stripeToken: string, riderId: string) => (dispatch: any) => {
  const { ridersAddPaymentSourceRequest, ridersAddPaymentSourceSuccess, ridersAddPaymentSourceFailure } = actionCreators
  dispatch(ridersAddPaymentSourceRequest())
  return riderService
    .addRiderPaymentSource(stripeToken, riderId)
    .then((wallet: IWalletWithSources) => {
      dispatch(ridersAddPaymentSourceSuccess(wallet, riderId))
      // history.push(`/riders/${riderId}/profile/wallet`) TODO: move this to wherever the payment source is added
    })
    .catch(({ data }) => {
      //the response is an http payload
      //data contains an error string
      dispatch(ridersAddPaymentSourceFailure(data))
    })
}

export const updateDefaultPaymentSource = (paymentSourceId: string, riderId: string) => (dispatch: any) => {
  const {
    ridersUpdateDefaultPaymentSourceRequest,
    ridersUpdateDefaultPaymentSourceSuccess,
    ridersUpdateDefaultPaymentSourceFailure
  } = actionCreators
  dispatch(ridersUpdateDefaultPaymentSourceRequest())
  return riderService
    .updateDefaultPaymentSource({
      userId: riderId,
      source: paymentSourceId
    })
    .then((wallet: IWalletWithSources) => {
      dispatch(ridersUpdateDefaultPaymentSourceSuccess(wallet, riderId))
    })
    .catch(({ data }) => {
      //the response is an http payload
      //data contains an error string
      dispatch(ridersUpdateDefaultPaymentSourceFailure(data))
    })
}

export const removeRiderPaymentSource = (paymentSourceId: string, riderId: any) => (dispatch: any) => {
  const {
    ridersRemovePaymentSourceRequest,
    ridersRemovePaymentSourceSuccess,
    ridersRemovePaymentSourceFailure
  } = actionCreators
  dispatch(ridersRemovePaymentSourceRequest())
  return riderService
    .removeRiderPaymentSource(paymentSourceId, riderId)
    .then((response: any) => {
      dispatch(ridersRemovePaymentSourceSuccess(paymentSourceId, riderId))
    })
    .catch((error: string) => {
      dispatch(ridersRemovePaymentSourceFailure(error))
    })
}

export const createRider = (rider: IRiderObject) => (dispatch: any) => {
  const { ridersCreateRequest, ridersCreateSuccess, ridersCreateFailure } = actionCreators
  dispatch(ridersCreateRequest())
  return riderService
    .createRider(rider)
    .then((response: any) => {
      rider.id = response.id
      dispatch(ridersCreateSuccess(rider))
    })
    .catch(({ data }) => {
      dispatch(ridersCreateFailure(data))
    })
}

export const deactivateRider = (rider: IRiderObject) => (dispatch: any) => {
  const { ridersDeactivateRequest, ridersDeactivateSuccess, ridersDeactivateFailure } = actionCreators
  dispatch(ridersDeactivateRequest())
  return riderService.deactivateRider(rider.id).then(
    (response: any) => {
      rider.isActive = false
      dispatch(ridersDeactivateSuccess(rider))
    },
    (error: string) => {
      dispatch(ridersDeactivateFailure(error, rider))
    }
  )
}

export const getRiderAssistanceList = (riderId: string) => (dispatch: any) => {
  const { ridersAssistanceListRequest, ridersAssistanceListSuccess, ridersAssistanceListFailure } = actionCreators
  dispatch(ridersAssistanceListRequest())
  return riderService.getRiderAssistanceList(riderId).then(
    (response: any) => {
      const { id, assistances } = response
      dispatch(ridersAssistanceListSuccess(id, assistances))
    },
    (error: string) => {
      dispatch(ridersAssistanceListFailure(error))
    }
  )
}

export function searchRidersForTrip(dto: IRiderFilters): any {
  const { tripRiderSearchRequest, tripRiderSearchSuccess, tripRiderSearchFailure } = actionCreators

  return (dispatch: any) => {
    dispatch(tripRiderSearchRequest(dto))
    return riderService.getMany(dto).then(
      payload => {
        console.log('rider search results:', payload.data.items)
        return dispatch(tripRiderSearchSuccess(payload.data))
      },
      (error: string) => dispatch(tripRiderSearchFailure(error))
    )
  }
}

export const getMany = (filters: IRiderFilters) => (dispatch: any) => {
  const { ridersListRequest, ridersListSuccess, ridersListFailure } = actionCreators
  dispatch(ridersListRequest())
  return riderService.getMany(filters).then(
    (response: any) => {
      dispatch(ridersListSuccess(response.data))
    },
    ({ data }) => {
      dispatch(ridersListFailure(data))
      setTimeout(() => {
        dispatch(ridersListFailure(''))
      }, 5000)
    }
  )
}

export const getManyRiderJoinRequest = (filters: IRiderFilters) => (dispatch: any) => {
  const { fetchRidersJoinRequest, fetchRidersJoinRequestSuccess, fetchRidersJoinRequestFailure } = actionCreators
  dispatch(fetchRidersJoinRequest())
  return riderService.getManyRiderJoinRequest(filters).then(
    (response: any) => {
      dispatch(fetchRidersJoinRequestSuccess(response.data))
    },
    ({ data }) => {
      dispatch(fetchRidersJoinRequestFailure(data))
      setTimeout(() => {
        dispatch(fetchRidersJoinRequestFailure(''))
      }, 5000)
    }
  )
}

export const getRiderLocationList = (riderId: string) => (dispatch: any) => {
  const { ridersLocationListRequest, ridersLocationListSuccess, ridersLocationListFailure } = actionCreators
  dispatch(ridersLocationListRequest())
  return riderService.getRiderLocationList(riderId).then(
    (response: any) => {
      const { id, locations } = response
      dispatch(ridersLocationListSuccess(id, locations))
    },
    (error: string) => {
      dispatch(ridersLocationListFailure(error))
    }
  )
}

export const getRiderLocationActivityList = (riderId: string) => (dispatch: any) => {
  const {
    ridersLocationActivityListRequest,
    ridersLocationActivityListSuccess,
    ridersLocationActivityListFailure
  } = actionCreators
  dispatch(ridersLocationActivityListRequest())
  return riderService.getRiderLocationActivityList(riderId).then(
    (response: any) => {
      const { id, locationActivity } = response
      dispatch(ridersLocationActivityListSuccess(id, locationActivity))
    },
    (error: string) => {
      dispatch(ridersLocationActivityListFailure(error))
    }
  )
}

export const getRiderMembershipList = (riderId: string) => (dispatch: any) => {
  const { ridersMembershipListRequest, ridersMembershipListSuccess, ridersMembershipListFailure } = actionCreators
  dispatch(ridersMembershipListRequest())
  dispatch(membershipListRequest())
  dispatch(organizationActionCreators.organizationListRequest())
  return membershipRequestService.getMembershipListByRiderId(riderId).then(
    (response: any) => {
      const { membershipList, organizationList } = response
      dispatch(ridersMembershipListSuccess(riderId, membershipList))
      dispatch(membershipListSuccess(membershipList))
      dispatch(organizationActionCreators.organizationListSuccess(organizationList))
    },
    (error: string) => {
      dispatch(ridersMembershipListFailure(error))
      dispatch(membershipListFail(error))
      dispatch(organizationActionCreators.organizationListFail(error))
    }
  )
}

export const updateRiderServiceMemberships = (dto: IUpdateServiceMemberships) => (dispatch: any) => {
  const { riderMembershipUpdateRequest, riderMembershipUpdateFailure, riderMembershipUpdateSuccess } = actionCreators
  dispatch(riderMembershipUpdateRequest())
  return membershipRequestService.updateRiderServiceMemberships(dto).then(
    (response: any) => {
      dispatch(riderMembershipUpdateSuccess(dto.id))
    },
    (error: string) => {
      dispatch(riderMembershipUpdateFailure(error))
    }
  )
}

export const getRiderMobilityOptionList = (riderId: string) => (dispatch: any) => {
  const {
    ridersMobilityOptionsListRequest,
    ridersMobilityOptionsListSuccess,
    ridersMobilityOptionsListFailure
  } = actionCreators
  dispatch(ridersMobilityOptionsListRequest())
  return riderService.getRiderMobilityOptionList(riderId).then(
    (response: any) => {
      const { id, mobilities } = response
      dispatch(ridersMobilityOptionsListSuccess(id, mobilities))
    },
    (error: string) => {
      dispatch(ridersMobilityOptionsListFailure(error))
    }
  )
}

export const getRiderPersonalInfo = (riderId: string) => (dispatch: any) => {
  const { ridersPersonalInfoRequest, ridersPersonalInfoSuccess, ridersPersonalInfoFailure } = actionCreators
  dispatch(ridersPersonalInfoRequest())
  return riderService.getRiderPersonalInfo(riderId).then(
    (response: any) => {
      dispatch(ridersPersonalInfoSuccess(response))
      return response
    },
    (error: string) => {
      dispatch(ridersPersonalInfoFailure(error))
    }
  )
}

export const archiveRider = (rider: IRiderObject) => (dispatch: any) => {
  const { ridersArchiveRequest, ridersArchiveSuccess, ridersArchiveFailure } = actionCreators
  dispatch(ridersArchiveRequest())
  return riderService.archiveRider(rider.id).then(
    (response: any) => {
      rider.isArchived = true
      dispatch(ridersArchiveSuccess(rider))
    },
    (error: string) => {
      dispatch(ridersArchiveFailure(error, rider))
    }
  )
}

export const restoreArchiveRider = (rider: IRiderObject) => (dispatch: any) => {
  const { ridersRestoreArchiveRequest, ridersRestoreArchiveSuccess, ridersRestoreArchiveFailure } = actionCreators
  dispatch(ridersRestoreArchiveRequest())
  return riderService.restoreArchiveRider(rider.id).then(
    (response: any) => {
      rider.isArchived = false
      dispatch(ridersRestoreArchiveSuccess(rider))
    },
    (error: string) => {
      dispatch(ridersRestoreArchiveFailure(error, rider))
    }
  )
}

export const updateRiderAssistances = (rider: IRiderObject, assistances: string[]) => (dispatch: any) => {
  const {
    ridersUpdateAssistancesRequest,
    ridersUpdateAssistancesSuccess,
    ridersUpdateAssistancesFailure
  } = actionCreators
  dispatch(ridersUpdateAssistancesRequest())
  return riderService.updateRiderAssistances({ id: rider.id, assistances }).then(
    (response: any) => {
      dispatch(ridersUpdateAssistancesSuccess(rider, assistances))
    },
    (error: string) => {
      dispatch(ridersUpdateAssistancesFailure(error))
    }
  )
}

export const updateRiderLocations = (rider: IRiderObject, locations: IRiderLocationObject[]) => (dispatch: any) => {
  const { ridersUpdateLocationsRequest, ridersUpdateLocationsSuccess, ridersUpdateLocationsFailure } = actionCreators
  dispatch(ridersUpdateLocationsRequest())
  return riderService.updateRiderLocations(rider.id, locations).then(
    (response: any) => {
      dispatch(ridersUpdateLocationsSuccess(rider, locations))
    },
    ({ data }) => {
      dispatch(ridersUpdateLocationsFailure(data))
      setTimeout(() => {
        dispatch(ridersUpdateLocationsFailure(''))
      }, 5000)
      throw new Error(data)
    }
  )
}

export const updateRiderMemberships = (rider: IRiderObject, memberships: IMembershipObject[]) => (dispatch: any) => {
  const {
    ridersUpdateMembershipsRequest,
    ridersUpdateMembershipsSuccess,
    ridersUpdateMembershipsFailure
  } = actionCreators
  dispatch(ridersUpdateMembershipsRequest())
  return riderService.updateRiderMemberships({ id: rider.id, memberships }).then(
    (response: any) => {
      dispatch(ridersUpdateMembershipsSuccess(rider, memberships))
    },
    (error: string) => {
      dispatch(ridersUpdateMembershipsFailure(error))
    }
  )
}

export const updateRiderMobilities = (
  rider: IRiderObject,
  mobilityList: string[],
  primaryMobilityId: string,
  allowAttendant: boolean
) => (dispatch: any) => {
  const { ridersUpdateMobilitiesRequest, ridersUpdateMobilitiesSuccess, ridersUpdateMobilitiesFailure } = actionCreators
  dispatch(ridersUpdateMobilitiesRequest())
  return riderService
    .updateRiderMobilities({
      id: rider.id,
      mobilities: mobilityList,
      primaryMobilityId
    })
    .then(
      (response: any) => {
        const { id, mobilities } = response
        dispatch(ridersUpdateMobilitiesSuccess(id, mobilities, allowAttendant))
      },
      (error: string) => {
        dispatch(ridersUpdateMobilitiesFailure(error))
      }
    )
}

export const updateRiderPersonalInfo = (rider: IRiderObject) => (dispatch: any) => {
  const {
    ridersUpdatePersonalInfoRequest,
    ridersUpdatePersonalInfoSuccess,
    ridersUpdatePersonalInfoFailure
  } = actionCreators
  dispatch(ridersUpdatePersonalInfoRequest())
  return riderService.updateRiderPersonalInfo(rider).then(
    async (response: any) => {
      dispatch(ridersUpdatePersonalInfoSuccess(rider))
      return response
    },
    ({ data }) => {
      dispatch(ridersUpdatePersonalInfoFailure(data))
    }
  )
}

export const applyPromotion = (aPromotion: IApplyPromotion) => {
  const { applyPromotion, applyPromotionSuccess, applyPromotionFailure } = actionCreators
  return async (dispatch: Dispatch) => {
    dispatch(applyPromotion(aPromotion.userId))
    promotionsService.applyPromotion(aPromotion).then(
      (promotion: IAppliedPromotion) => {
        dispatch(applyPromotionSuccess(promotion))
        return promotion
      },
      (e: string) => {
        dispatch(applyPromotionFailure(e))
      }
    )
  }
}

export const getAppliedPromotions = (userId: string) => {
  const { getAppliedPromotions, getAppliedPromotionsSuccess, getAppliedPromotionsFailure } = actionCreators
  return async (dispatch: Dispatch) => {
    dispatch(getAppliedPromotions(userId))
    promotionsService.getAppliedPromotions(userId).then(
      (appliedPromotions: IAppliedPromotion[]) => {
        dispatch(getAppliedPromotionsSuccess(userId, appliedPromotions))
        return appliedPromotions
      },
      (e: string) => {
        dispatch(getAppliedPromotionsFailure(e))
      }
    )
  }
}

export const deleteAppliedPromotion = (promotionId: string, walltetId: string, userId: string) => {
  const { deleteAppliedPromotionFailure } = actionCreators
  return async (dispatch: Dispatch) => {
    promotionsService.deleteAppliedPromotion(promotionId, walltetId).then(
      (appliedPromotions: IAppliedPromotion) => {
        location.reload()
        return appliedPromotions
      },
      (e: string) => {
        dispatch(deleteAppliedPromotionFailure(e))
      }
    )
  }
}

export const getRecuringTripByRiderId = (riderId: string) => (dispatch: any) => {
  const { getRiderRecurringTripsRequest, getRiderRecurringTripsSuccess, getRiderRecurringTripsFailure } = actionCreators
  dispatch(getRiderRecurringTripsRequest())
  return tripService
    .getRecuringTripByRiderId(riderId)
    .then(res => {
      dispatch(getRiderRecurringTripsSuccess(res.data))
      return res.data
    })
    .catch(err => {
      dispatch(getRiderRecurringTripsFailure(err.data))
    })
}

export const destroyRecurringTripTask = (recurrringTripId: string) => (dispatch: any) => {
  const { destroyRecurringTripTaskFailure, destroyRecurringTripTaskSuccess } = actionCreators
  tripService
    .destroyRecurringTask(recurrringTripId)
    .then(res => {
      console.log(`task id: ${res.data} destroyed`)
      dispatch(destroyRecurringTripTaskSuccess(res.data))
    })
    .catch(err => {
      dispatch(destroyRecurringTripTaskFailure(err.data))
    })
}

export const refundPayment = (params: IRefundTransactionDTO, refundableAmount: number) => (dispatch: any) => {
  const { refundPaymentFailure, refundPaymentSuccess } = actionCreators
  if (params.amount <= refundableAmount) {
    riderService
      .refundPayment(params)
      .then(() => {
        dispatch(refundPaymentSuccess())
        // double then statement to make sure changes are reflected. Record is passed to stripe before a webhook record it in goin-payment
        setTimeout(() => {
          dispatch(getRiderPersonalInfo(params.riderId))
          dispatch(getRiderWalletTransactions(params.riderId))
        }, 1500)
      })
      .then(() => {
        setTimeout(() => {
          dispatch(getRiderPersonalInfo(params.riderId))
          dispatch(getRiderWalletTransactions(params.riderId))
        }, 1500)
      })
      .catch(err => {
        dispatch(refundPaymentFailure(err.data))
      })
  } else {
    dispatch(refundPaymentFailure(`Amount to big. You can only refund: $${refundableAmount / 100}`))
  }
}

export const getRefundedAmount = (stripeTransactionId: string, walletId: string) => (dispatch: any) => {
  const { getRefundedAmountSuccess, getRefundedAmountFailure } = actionCreators
  riderService
    .getRefundedAmount(stripeTransactionId, walletId)
    .then(value => {
      dispatch(getRefundedAmountSuccess(value))
    })
    .catch(err => {
      dispatch(getRefundedAmountFailure(err.data))
    })
}

export const assignRefundDetails = (params: IRefundTransactionDTO) => (dispatch: any) => {
  const { assignRefundDetails } = actionCreators
  dispatch(assignRefundDetails(params))
}

export const riderChangeLog = (params: IRiderChangeLogDTO) => (dispatch: any) => {
  const { getRiderChangeLogRequest, getRiderChangeLogSuccess, getRiderChangeLogFailure } = actionCreators
  dispatch(getRiderChangeLogRequest())
  return riderService
    .riderChangeLog(params)
    .then((res: any) => {
      dispatch(getRiderChangeLogSuccess(res.data))
      return res.data
    })
    .catch((err: any) => {
      dispatch(getRiderChangeLogFailure(err))
    })
}

export const rechargeWallet = (walletTransactionId: string) => (dispatch: any) => {
  const { rechargeWalletRequest, rechargeWalletSuccess, rechargeWalletFailure } = actionCreators

  dispatch(rechargeWalletRequest(walletTransactionId))
  return riderService
    .rechargeWalletTransaction(walletTransactionId)
    .then((response: any) => {
      dispatch(rechargeWalletSuccess())
    })
    .catch((error: any) => {
      dispatch(rechargeWalletFailure(error))
    })
}



// WEBPACK FOOTER //
// ./src/state/actions/riders/index.ts